<label [for]="id()" class="input__label" [class.input__label--hidden]="!label()">{{
  label()
}}</label>
<div
  class="input"
  [class.input--readonly]="readonly()"
  [class.input--required]="!!error()"
  [class.input--disabled]="disabled"
>
  @if (icon()) {
    <app-svg-icon class="input__icon" [blank]="true" [icon]="icon()" />
  }
  <input
    class="input__field"
    [class.input__field--icon]="icon()"
    [class.input__field--light]="lightInput()"
    [id]="id() || name()"
    [name]="name()"
    [readonly]="readonly()"
    [required]="required()"
    [type]="type()"
    [(ngModel)]="value"
    [placeholder]="placeholder()"
    (input)="onChange(value)"
    (blur)="onTouched()"
    [autocomplete]="autoComplete()"
    [max]="max()"
    [disabled]="disabled"
  />
  @if (!!error()) {
    <span class="input__error">{{ error() }}</span>
  }
</div>
